module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff2";